// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  font-family: Roboto, sans-serif;
  position: relative;
}

.messages-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: calc(100% - 77px);
  width: 100%;
  position: relative; /* Creates positioning context for absolute-positioned portal container */
}

.messages-list-typing-indicator {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  font-family: Roboto, arial, sans-serif;
  font-size: 12px;
  color: rgba(71,71,71,1);
}

/* Compose reply preview styles (when clicking Reply button) */
.compose-reply-preview {
  background-color: rgb(186, 193, 184);
  margin: 0;
  margin-bottom: 8px;
  margin-left: 10px;
  margin-right: auto;
  max-width: 85%;
  width: fit-content;
  border-radius: 17px;
  font-size: 12px;
  font-style: italic;
  font-family: Roboto, sans-serif;
  align-self: flex-start;
}

.compose-reply-preview-content {
  padding: 8px 12px;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-style: italic;
}

.compose-reply-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-style: italic;
}

.compose-reply-preview-label {
  font-size: 12px;
  color: #666;
  font-weight: bold;
  font-family: Roboto, sans-serif;
  font-style: italic;
}

.compose-reply-preview-close {
  background: none;
  border: none;
  color: #666;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  font-family: Roboto, sans-serif;
}

.compose-reply-preview-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.compose-reply-preview-message {
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 200px;
  max-width: calc(100% - 30px);
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-style: italic;
}

/* Compose reply preview styles (when inside message input container) */
.message-input-container .compose-reply-preview {
  background-color: rgb(186, 193, 184);
  margin: 8px 10px 0 10px;
  max-width: 50%;
  min-width: 200px;
  width: fit-content;
  border-radius: 12px;
  font-size: 12px;
  font-style: italic;
  font-family: Roboto, sans-serif;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/Messages.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB,EAAE,yEAAyE;AAC/F;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,sCAAsC;EACtC,eAAe;EACf,uBAAuB;AACzB;;AAEA,8DAA8D;AAC9D;EACE,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;EACE,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;AAChB","sourcesContent":[".messages {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  font-family: Roboto, sans-serif;\n  position: relative;\n}\n\n.messages-list {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: calc(100% - 77px);\n  width: 100%;\n  position: relative; /* Creates positioning context for absolute-positioned portal container */\n}\n\n.messages-list-typing-indicator {\n  position: absolute;\n  bottom: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-family: Roboto, arial, sans-serif;\n  font-size: 12px;\n  color: rgba(71,71,71,1);\n}\n\n/* Compose reply preview styles (when clicking Reply button) */\n.compose-reply-preview {\n  background-color: rgb(186, 193, 184);\n  margin: 0;\n  margin-bottom: 8px;\n  margin-left: 10px;\n  margin-right: auto;\n  max-width: 85%;\n  width: fit-content;\n  border-radius: 17px;\n  font-size: 12px;\n  font-style: italic;\n  font-family: Roboto, sans-serif;\n  align-self: flex-start;\n}\n\n.compose-reply-preview-content {\n  padding: 8px 12px;\n  font-family: Roboto, sans-serif;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.compose-reply-preview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n  font-family: Roboto, sans-serif;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.compose-reply-preview-label {\n  font-size: 12px;\n  color: #666;\n  font-weight: bold;\n  font-family: Roboto, sans-serif;\n  font-style: italic;\n}\n\n.compose-reply-preview-close {\n  background: none;\n  border: none;\n  color: #666;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 0;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n  font-family: Roboto, sans-serif;\n}\n\n.compose-reply-preview-close:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.compose-reply-preview-message {\n  color: #333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 200px;\n  max-width: calc(100% - 30px);\n  font-family: Roboto, sans-serif;\n  font-size: 12px;\n  font-style: italic;\n}\n\n/* Compose reply preview styles (when inside message input container) */\n.message-input-container .compose-reply-preview {\n  background-color: rgb(186, 193, 184);\n  margin: 8px 10px 0 10px;\n  max-width: 50%;\n  min-width: 200px;\n  width: fit-content;\n  border-radius: 12px;\n  font-size: 12px;\n  font-style: italic;\n  font-family: Roboto, sans-serif;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
